const BIZ_NUMBER_WEIGHTS = [1, 3, 7, 1, 3, 7, 1, 3, 5]

export function sanitizeBizNumberInput(value: string): string {
  return value.replace(/\D/g, '').slice(0, 10)
}

/** 123-45-67891 형태로 보기 좋게 끊어 준다. */
export function formatBizNumber(value: string): string {
  const digits = sanitizeBizNumberInput(value)
  if (digits.length <= 3) return digits
  if (digits.length <= 5) return `${digits.slice(0, 3)}-${digits.slice(3)}`
  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`
}

/** 국세청 사업자등록번호 검사식. 오타를 서버에 보내기 전에 걸러 준다. */
export function isBizNumberValid(value: string): boolean {
  const digits = sanitizeBizNumberInput(value)
  if (digits.length !== 10) {
    return false
  }

  let sum = BIZ_NUMBER_WEIGHTS.reduce(
    (acc, weight, index) => acc + Number(digits[index]) * weight,
    0,
  )
  sum += Math.floor((Number(digits[8]) * 5) / 10)

  return (10 - (sum % 10)) % 10 === Number(digits[9])
}
